<template>
  <MessageBarV02
    v-if="message"
    icon="mdi-alert-circle"
    class="error-message-bar"
    type="error"
    dark
    dense
    dismissible
    tile
    transition="fade-transition"
  >
    {{ message }}
  </MessageBarV02>
</template>
<script>
import { MessageBarV02 } from '@mikmak/components';

export default {
  components: {
    MessageBarV02,
  },
  props: {
    message: String,
  },
};
</script>
<style>
.error-message-bar {
  position: absolute;
  width: 100%;
  z-index: 2;
}
</style>
